export default __webpack_public_path__ + "5dac40d0c0bf301aba3fd9be6ddcf3a9.svg";